import React from "react";
import "../../../../App.css";
import "./Home.css";
import { FRBanner } from "../../../Banner/Banner";
import ReactTooltip from "react-tooltip";
import { cdn } from "../../../../consts/cdn";

//Images
const BannerDesktop = cdn.images + "Home/Banner-Desktop-Compressed.jpg";
const BannerMobile = cdn.images + "Home/Banner-Mobile.jpg";

function Home() {
  return (
    <>
      <div className="home">
        <FRBanner
          imgdesktop={BannerDesktop}
          imgmobile={BannerMobile}
          bold1="vNOTES"
          text1="La prochaine évolution en chirurgie"
          text2="gynécologique mini-invasive"
          buttons={[
            {
              text: "Pourquoi la chirurgie vNOTES ?",
              route: "/fr/whyvnotes",
            },
            {
              text: "Informations patientes",
              route: "/fr/patientresources",
            },
          ]}
          color="#365B7E"
        />
        <ReactTooltip />
      </div>
    </>
  );
}

export default Home;
